import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { shippingAddressStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsShippingAddress";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

shippingAddressStyles.addressDisplay = mergeToNew(shippingAddressStyles.addressDisplay, {
    wrapper: {
        css: css`
            padding: 4px;
        `,
    },
});
shippingAddressStyles.titleText = mergeToNew(shippingAddressStyles.titleText, {
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 4px;
        width: 100%;
    `,
});
